import { Link } from 'react-router-dom';
import logo from '/logo1.png';
function Header() {
    return (
        // <h1>Header</h1>
        <>
            <div className=" border-b bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-600   ">
                <div className='md:w-[90%] w-[98%] flex mx-auto'>

                
                <div className="md:h-20 h-10 md:p-3 p-2 w-[30%] ">
                    <Link to={'/'} ><img src={logo} alt="spl 2025" className='md:h-16  h-8 my-auto' /></Link>
                </div>
                <div className='flex h-full my-auto md:text-lg text-sm w-[70%] font-mono flex-row-reverse  md:gap-4 gap-2 text-white p-4'>
                <Link to={'/profile'} >Profile</Link>
                        <Link to={'/form'} >Form</Link>
                    <Link to={'/about'} >About</Link>
                    <Link to={'/'} >Home</Link>
                    </div>
                    </div>
            </div>
        </>
    )
}

export default Header;
